function generateShaktiWhatsappMessage(recommendations) {
  if (!recommendations) return "";

  const astrology = recommendations?.astrology || {};
  const quiz = recommendations?.quiz || {};
  const data = recommendations?.recommendations || {};

  const rudraksha = data?.rudraksha || [];
  const gemstones = data?.gemstones || [];
  const template = recommendations?.template || "";

  return `
🙏 Hello Subrahmanya Rudraksha Team,

I have completed my Shakti AI Spiritual Consultation and would like your guidance.

━━━━━━━━━━━━━━━━━━━━━━

🌙 Astrology Profile

• Rashi: ${astrology?.rashi || "N/A"}
• Nakshatra: ${astrology?.nakshatra || "N/A"}
• Ruling Planet: ${astrology?.rulingPlanet || "N/A"}

━━━━━━━━━━━━━━━━━━━━━━

🎯 Spiritual Goal

• Primary Purpose: ${quiz?.primaryPurpose || "N/A"}

${
  astrology?.spiritualTags?.length
    ? `• Spiritual Tags: ${astrology.spiritualTags.join(", ")}`
    : ""
}

━━━━━━━━━━━━━━━━━━━━━━

📿 Recommended Rudraksha

${
  rudraksha.length
    ? rudraksha
        .map(
          (r, index) => `
${index + 1}. ${r.name}
• Deity: ${r.deity || "N/A"}
• Planet: ${r.planet || "N/A"}
• Benefits: ${(r.benefits || []).join(", ") || "N/A"}
• Helps With: ${(r.problems || []).join(", ") || "N/A"}
• Match Score: ${r.score || 0}%`,
        )
        .join("\n\n")
    : "No Rudraksha Recommended"
}

━━━━━━━━━━━━━━━━━━━━━━

💎 Recommended Gemstones

${
  gemstones.length
    ? gemstones
        .map(
          (g, index) => `
${index + 1}. ${g.name}
• Associated Deities: ${(g.gods || []).join(", ") || "N/A"}
• Match Score: ${g.score || 0}%`,
        )
        .join("\n\n")
    : "No Gemstones Recommended"
}

━━━━━━━━━━━━━━━━━━━━━━

🤖 Shakti AI Insight

${template || "N/A"}

━━━━━━━━━━━━━━━━━━━━━━

Please help me understand these recommendations and suggest the most suitable Rudraksha and Gemstone for me.

Thank you 🙏
`.trim();
}

export function generateShaktiWhatsappUrl(recommendations) {
  const message = generateShaktiWhatsappMessage(recommendations);

  return `https://wa.me/918750122331?text=${encodeURIComponent(message)}`;
}
